import { useState } from "react";

export interface ValidationErrors {
  [key: string]: ValidationErrors | string[];
}

// turns C# validation errors into a JS object with property nesting. So that it can be passed
// in react components more easily
export const useValidationErrors = (): {
  setValidationErrors: (errors: ValidationErrors) => void;
  validationErrors: ValidationErrors;
} => {
  const [_validationErrors, _setValidationErrors] = useState<ValidationErrors>({});

  const setValidationErrors = (errors: ValidationErrors) => {
    // returning {} is important so we dont have to use ?. like validationErrors?.firstName everywhere at the first level

    if (errors === undefined) {
      _setValidationErrors({});
    } else {
      const _errors = convertToObject(errors) || {};
      console.log("errorsProps", _errors);
      _setValidationErrors(_errors);
    }
  };

  // INPUT:
  // const errors = {
  //   "FirstName": ["firstName Error"],
  //   "Child.DateOfBirth": ["child's dateOfBirth error"],
  //   "Employments[0].AssignmentId": ["employment's assignment error 0"],
  //   "Employments[1].AssignmentId": ["employment's assignment error 1"],
  // };

  // OUPUT:
  // const errors: {
  // 	firstName: ["firstName Error"],
  // 	child: {
  // 		dateOfBirth: ["child's dateOfBirth error"],
  // 	}
  // 	employments: [
  // 		{ assignmentId: "employment's assignment error 0" },
  // 		{ assignmentId: "employment's assignment error 1" },
  // 	],
  // }
  const convertToObject = (errors: ValidationErrors): ValidationErrors => {
    const result: any = {};

    for (const key in errors) {
      const value = errors[key];
      const parts = key.split(/[.\[\]]/).filter(Boolean); // split by . or [] and remove empty parts

      let currentObj = result;
      for (let i = 0; i < parts.length - 1; i++) {
        const part = parts[i];
        const camelCasePart = part.charAt(0).toLowerCase() + part.slice(1);
        if (!(camelCasePart in currentObj)) {
          if (/^\d+$/.test(parts[i + 1])) {
            currentObj[camelCasePart] = [];
          } else {
            currentObj[camelCasePart] = {};
          }
        }
        currentObj = currentObj[camelCasePart];
      }

      const lastPart = parts[parts.length - 1];
      const camelCaseLastPart = lastPart.charAt(0).toLowerCase() + lastPart.slice(1);
      if (/^\d+$/.test(camelCaseLastPart)) {
        currentObj.push({ [parts[parts.length - 2]]: value[0] });
      } else {
        currentObj[camelCaseLastPart] = value;
      }
    }

    return result;
  };

  return {
    setValidationErrors: (errors: ValidationErrors) => setValidationErrors(errors),
    validationErrors: _validationErrors,
  };
};
